import React from 'react'
import { Col } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { Dropdown } from 'react-bootstrap'
import {
} from 'utlis/AppMessages/AppMessages'
import { connect } from 'react-redux'

function ProductMultiplierTopBar(props) {
    const { categories, getProducts_ } = props
    return (
        <Col xs={12} md={12} lg={12} className="px-0">
            <div className="pad-12-B">
                <div className="d-flex justify-content-start multiplier-top-button">
                    <div className="d-flex">
                        <div className="rt_item st-form form-sm mb-0 me-2">
                            <select
                                className="form-control"
                                placeholder="Action"
                                id="categories"
                                onChange={getProducts_}
                            >
                                <option key={0} value={""}>Select Catergory</option>

                                {(categories && categories.length) && categories.map((item, index) => (
                                    <optgroup label={item.category_name} key={index}>
                                        {(Array.isArray(item.sub_categories)) && item.sub_categories.length > 0 ?
                                            item.sub_categories.map(e =>
                                                <option key={e.category_id} value={e.category_id}>
                                                    {e.category_name}
                                                </option>
                                            ) :
                                            <option key={item.category_id} value={item.category_id}>
                                                {item.category_name}
                                            </option>
                                        }
                                    </optgroup>
                                )
                                )}
                            </select>
                        </div>
                        <div className="rt_item st-form form-sm mb-0 me-2">
                            <select
                                className="form-control"
                                placeholder="Action"
                                id="parentCategoryName">
                                <option value="">Action</option>
                                <option value="">Action</option>
                                <option value="">Action</option>
                            </select>
                        </div>
                        <div className="rt_item st-form form-sm st-form-with-icon-right search mb-0 me-2">
                            <input type="text" className="form-control" placeholder="Search By Keywords" />
                            <div className="icon">
                                <FeatherIcon
                                    icon="search"
                                    size="16"
                                    className="icon-main" />
                            </div>
                        </div>
                    </div>
                    <div className="rt_item button-container export-options me-2">
                        <Dropdown className="st-bs-dropdown no-down-icon">
                            <Dropdown.Toggle
                                className="st-btn st-btn-sm no-min-width st-btn-outline border d-flex align-items-center justify-content-center"
                            >
                                <FeatherIcon
                                    icon="edit"
                                    size="14"
                                    className="icon me-2" />
                                <span>Edit Columns</span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__costPrice}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__costPrice(true) : props.setColumn__costPrice(false)
                                        }} />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Cost Price</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__brandMultiplier}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__brandMultiplier(true) : props.setColumn__brandMultiplier(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Brand Multiplier</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__categoryMultiplier}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__categoryMultiplier(true) : props.setColumn__categoryMultiplier(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Category Multiplier</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__productMultiplier}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__productMultiplier(true) : props.setColumn__productMultiplier(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Product Multiplier</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__shippingMultiplier}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__shippingMultiplier(true) : props.setColumn__shippingMultiplier(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Shipping Multiplier</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__creditCardFee}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__creditCardFee(true) : props.setColumn__creditCardFee(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Credit Card Fee</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__misc}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__misc(true) : props.setColumn__misc(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Miscellaneous</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__totalPrice}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__totalPrice(true) : props.setColumn__totalPrice(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Price($)</span>
                                </label>

                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="d-none"
                                        defaultChecked={props.column__totalProfit}
                                        onChange={ev => {
                                            (ev.target.checked) ? props.setColumn__totalProfit(true) : props.setColumn__totalProfit(false)
                                        }}
                                    />
                                    <span className="box d-flex align-items-center justify-content-center border">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon position-relative" />
                                    </span>
                                    <span className="text ms-2">Profit($)</span>
                                </label>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0 me-2">
                        <button
                            type="button"
                            className="st-btn st-btn-sm border no-min-width st-btn-outline d-flex align-items-center justify-content-center "
                            onClick={() => { }}
                        >
                            <FeatherIcon
                                icon="eye"
                                size="14"
                                className="icon me-1" />
                            <span>Default View</span>
                        </button>
                    </div>

                    <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0 me-2">
                        <button
                            type="button"
                            className="st-btn st-btn-sm st-btn-gray no-min-width d-flex align-items-center justify-content-center "
                            onClick={() => { }}
                        >
                            <FeatherIcon
                                icon="filter"
                                size="14"
                                className="icon me-1" />
                            <span>Filter</span>
                        </button>
                    </div>
                </div>
            </div>
        </Col >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

export default connect(getDataFromStore, null)(ProductMultiplierTopBar)